module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logos/logo-18-c92440bc2b4c7f9bbca1554e0905d741.png";